export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/exam/signin',
                method: 'POST',
                body: payload,
            };
        }
       
    })
